import React from 'react';
import styled, { css } from 'styled-components/macro';
import { Button } from './Button';
import { FiInstagram, FiLinkedin, FiFacebook } from 'react-icons/fi';

const Section = styled.section`
  width: 100%;
  height: 100%;
  background: #000d1a;
  // padding: rem 0rem;
`;

const Container = styled.div`
  padding: 1rem calc((100vw - 1300px) / 2);
  display: grid;
  grid-template-columns: 2fr 1fr;
  // grid-template-rows: 800px;

  @media screen and (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const ColumnLeft = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  line-height: 1.4;
  padding: 1rem 2rem;
  order: 1;

  h1 {
    margin-bottom: 1rem;
    color: #fff;
    font-size: clamp(2.75rem, 6vw, 2rem);
  }

  p {
    margin-bottom: 2rem;
  }
`;

const ColumnRight = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: top;
  align-items: flex-start;
  line-height: 1.4;
  padding: 0rem 2rem;
  order: 1;
  border-left: 1px solid #fff;

  h1 {
    margin-bottom: 1rem;
    color: #fff;
    font-size: clamp(3.5rem, 6vw, 2rem);
  }

  p {
    color: #fff;
  }

  h4 {
    color: #fff;
    margin-top: 1rem;
    margin-bottom: 2rem;
  }

  span {
    color: #fff;
    margin-top: 2rem;
    text-decoration: underline;
    text-decoration-color: #cd853f;
  }
`;

const ColumnThird = styled.div`
  border-left: 1px solid #fff;
  height: 500px
  padding: 0rem 2rem;
  order: 2;
  display: flex;
  justify-content: center;
  align-items: center;

  @media screen and (max-width: 768px) {
   
  }

  img {
    width: 100%;
    height: 80%;
    object-fit: cover;

    @media screen and (max-width: 768px) {
      width: 80%;
      height: 90%;
    }
  }
`;

const SocailIcon = css`
  width: 50px;
  height: 50px;
  color: #cd853f;
  cursor: pointer;
  // border-radius: 50px;
  // background: #000d1a;
  padding: 10px;
  margin-right: 1rem;
  user-select: none;
  transition: 0.3s;

  &:hover {
    transform: scale(1.3);
  }
`;

const FbLinks = styled(FiFacebook)`
  ${SocailIcon}
`;

const InstaLinks = styled(FiInstagram)`
  ${SocailIcon}
`;

const LinkedLinks = styled(FiLinkedin)`
  ${SocailIcon}
`;

const ColumnIcon = styled.div`
  align-items: center;
  justify-content: center;
`;

const InfoSection = () => {
  return (
    <Section>
      <Container>
        <ColumnLeft>
          <h1>Let's find your</h1>
          <h1>Dream Home</h1>
          <ColumnIcon>
            <a
              href='https://www.facebook.com/BestPropertiesAtOrtigas'
              target='_blank'
              aria-label='Facebook'
            >
              <FbLinks />
            </a>
            <a
              href='https://www.facebook.com/BestPropertiesAtOrtigas'
              target='_blank'
              aria-label='Facebook'
            >
              <InstaLinks />
            </a>
            <a
              href='https://www.facebook.com/BestPropertiesAtOrtigas'
              target='_blank'
              aria-label='Facebook'
            >
              <LinkedLinks />
            </a>
          </ColumnIcon>
        </ColumnLeft>
        <ColumnRight>
          <h4>GET IN TOUCH</h4>
          <p>7F Estrancia West Wing</p>
          <p>Maralco Avenue</p>
          <p>Pasig City, 1605, Philippines</p>
          <span>(0906) 356 6166</span>
        </ColumnRight>
      </Container>
    </Section>
  );
};

export default InfoSection;
